import { List, Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { FundingMatchStatus, toLabel } from 'enums/funding-match-status';

import { dateFormat } from 'utils/DateHelper';
import { formatCurrency } from 'utils/NumberHelper';

const FundingMatchRecord = Record({
  amount: '',
  companyName: '',
  failingValidationRules: {},
  matchCompletion: 0,
  created: new Date(0),
  fundingSearchId: 0,
  lastChangeDate: new Date(0),
  lastUpdatedBy: '',
  matchedProductType: 0,
  matches: List(),
  period: 0,
  icon: null,
  notificaton: '',
  products: [],
  offer: null,
  productType: 0,
  profileCompletion: 0.0,
  revenue: 0,
  status: FundingMatchStatus.submitted,
  tradingPeriod: 0,
  statusReason: '',
  statusComment: '',
});

export default class FundingMatch extends FundingMatchRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {
      created: Hydrator.timestamp2Date,
      lastChangeDate: Hydrator.timestamp2Date,
      profileCompletion: Hydrator.toFloat,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new FundingMatch(hydrated);
  }

  get subtitle() {
    return `${this.tradingPeriodInYears}yr old, ${formatCurrency(this.revenue)} turnover`;
  }

  get statusAsLabel() {
    return toLabel(this.status);
  }

  get completion() {
    return Math.floor(this.profileCompletion);
  }

  get completionLabel() {
    const { completion } = this;

    if (completion >= 0 && completion < 40) {
      return 'More work to do';
    }

    if (completion >= 40 && completion < 65) {
      return 'Halfway there';
    }

    if (completion >= 65 && completion < 99) {
      return 'Almost there';
    }

    if (completion >= 99) {
      return 'Complete';
    }

    return '';
  }

  get tradingPeriodInYears() {
    return Math.floor((this.tradingPeriod || 0) / 12);
  }

  lastChangeDateFormatted(formatStr = 'Mo MMM') {
    return dateFormat(this.lastChangeDate, formatStr);
  }
}
